"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTypes = void 0;
var ButtonTypes;
exports.ButtonTypes = ButtonTypes;

(function (ButtonTypes) {
  ButtonTypes["PRIMARY"] = "primary";
  ButtonTypes["SECONDARY"] = "secondary";
  ButtonTypes["TERTIARY"] = "tertiary";
  ButtonTypes["WHITE"] = "white";
  ButtonTypes["PRODUCT"] = "product";
})(ButtonTypes || (exports.ButtonTypes = ButtonTypes = {}));